import React from 'react';

import PropTypes from 'prop-types';
import { Container, Videos, Title } from './styles';

import VideoItem from '~/components/Section05VideoItem';
// import UserImage from '~/assets/user-img-01.png';

import 'slick-carousel/slick/slick.css';
import Slider from 'react-slick';

import ArrowDown from '~/components/ArrowDown';

import { loadDepoimentos } from '~/services/api.depoimentos';

export default function Section05({ id }) {
  const videos = loadDepoimentos();
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Container id={id}>
      {/* <Title>
        Este ano o seu Imposto de Renda será diferente!
        <span>Faça acontecer um projeto social da PUC-SP!</span>
      </Title> */}
      <Title>Depoimentos</Title>
      <Videos>
        <Slider {...settings}>
          {videos.map((video) => (
            <VideoItem
              key={video.id}
              video={video.id_video}
              img_video={video.img_video}
              text={video.text}
              user={video.user}
              user_title={video.user_title}
              user_setor={video.user_setor}
              user_time={video.user_time}
            />
          ))}
        </Slider>
      </Videos>
      <ArrowDown toElement="faq" className="ArrowDown" />
    </Container>
  );
}

Section05.propTypes = {
  id: PropTypes.string,
};
